<template>
    <div>
        <b-form v-on:submit.prevent="saveSettings">
            <b-form-group label="Name">
                <b-form-input v-model="details.name"></b-form-input>
                <b-form-invalid-feedback v-if="errors.name">{{ errors.name[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Email">
                <b-form-input v-model="details.email"></b-form-input>
                <b-form-invalid-feedback v-if="errors.email">{{ errors.email[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Phone">
                <b-form-input type="tel" v-model="details.phone"></b-form-input>
                <b-form-invalid-feedback v-if="errors.phone">{{ errors.phone[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Password" description="Leave blank if you don't want to update your password">
                <b-form-input type="password" v-model="details.password"></b-form-input>
                <b-form-invalid-feedback v-if="errors.password">{{ errors.password[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
                <b-button size="lg" variant="primary" block disabled v-if="loading">
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                </b-button>
                <b-button size="lg" v-else type="submit" variant="primary" block>Save profile</b-button>
            </b-form-group>
        </b-form>

    </div>
</template>

<script>
    export default {
        name: "ProfileDetails",

        data(){
            return {
                loading: false,
                details: {},
                errors: [],
            }
        },

        mounted() {
            this.getProfileData();
        },

        methods: {
            getProfileData(){
                axios.get('/settings/profile').then(response => {
                    this.details = response.data;
                })
            },

            saveSettings() {
                this.loading = true;
                axios.post('/settings/profile', this.details).then(response => {
                    this.$toasted.show(response.data.message);
                    this.loading = false;
                }).catch(error => {
                    if (error.response.status == 422){
                        this.errors = error.response.data.errors;
                    }
                    this.loading = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>